import { compose, flattenProp } from 'recompose';
import { connect } from 'react-redux';
import { totalQuota } from 'reducers/dashboard/selectors';
import { totalCartQuantity } from 'reducers/cart/selectors';
import { dealershipSummary } from 'reducers/series/selectors';
import combineSelectors from 'utils/combineSelectors';

const mapStateToProps = combineSelectors({
  totalQuota,
  totalCartQuantity,
  dealershipSummary,
});

export default compose(
  connect(mapStateToProps),
  flattenProp('dealershipSummary'),
);
